import { Link } from "react-router-dom";
import { openCalendlyPopup } from "../integrations/calendly";

export const SOCIAL = {
    linkedin: "https://www.linkedin.com/company/summercrestai",
    instagram: "https://www.instagram.com/summercrestai/",
};

const linkClass =
    "font-sans text-[12px] uppercase tracking-[0.16em] text-cream/55 transition-colors duration-300 hover:text-gold";

export const Footer = () => (
    <footer data-testid="site-footer" className="grain relative border-t border-charcoal bg-obsidian">
        <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
            <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
                <div>
                    <div className="flex items-center gap-2.5">
                        <img src="/logo-white.png" alt="Summercrest AI" className="h-8 w-8 object-contain" />
                        <span className="font-serif text-xl uppercase tracking-[0.08em] text-cream">
                            Summercrest <span className="font-mono text-[11px] tracking-[0.2em] text-gold">AI</span>
                        </span>
                    </div>
                    <p className="mt-4 max-w-xs font-serif text-lg italic text-cream/70">
                        More bookings from the clients you already have.
                    </p>
                </div>
                <nav className="grid grid-cols-2 gap-x-14 gap-y-3 sm:grid-cols-3">
                    <Link to="/#how-it-works" data-testid="footer-how-it-works" className={linkClass}>
                        How It Works
                    </Link>
                    <Link to="/faq" data-testid="footer-faq" className={linkClass}>
                        FAQ
                    </Link>
                    <Link to="/privacy" data-testid="footer-privacy" className={linkClass}>
                        Privacy Policy
                    </Link>
                    <Link to="/terms" data-testid="footer-terms" className={linkClass}>
                        Terms
                    </Link>
                    <button
                        data-testid="footer-contact"
                        onClick={() => openCalendlyPopup()}
                        className={`${linkClass} text-left`}
                    >
                        Contact
                    </button>
                    <a
                        href={SOCIAL.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-linkedin"
                        className={linkClass}
                    >
                        LinkedIn
                    </a>
                    <a
                        href={SOCIAL.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram"
                        className={linkClass}
                    >
                        Instagram
                    </a>
                </nav>
            </div>
            <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-cream/10 pt-6 sm:flex-row sm:items-center">
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-cream/40">
                    © 2026 Summercrest AI — Client Reactivation Systems
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold/70">
                    One niche. One problem. One system. One outcome.
                </span>
            </div>
        </div>
    </footer>
);
